import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { useNavigator } from '@repo/toolkit/use-navigator'
import Button from '@repo/ui/button'
import { Column } from '@repo/ui/data-table'
import { MeetingPointIcon, PlusIcon, WorldIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { useRef } from 'react'

import { API } from '../../api/apis.config'
import DynamicDataTable, { DynamicTableRef } from '../../components/elements/dynamic-table'
import InformationToolTip from '../../components/elements/information-tooltip'
import UserNavBar from '../../components/elements/nav-bar'
import { Paths } from '../../lib/constants/path'
import { TripAddress } from '../../lib/types/models/trip-address/trip-address'

const TripAddressListPage = () => {
  const tableRef = useRef<DynamicTableRef<TripAddress>>(null)
  const { navigate, navigateWithEvent } = useNavigator()

  const columns: Column<TripAddress>[] = [
    {
      accessorKey: 'label',
      header: 'Titre',
      enableSorting: true,
      cell: (data) => data.row.original.label
    },
    {
      accessorKey: 'address1',
      header: 'Adresse',
      enableSorting: true,
      cell: (data) => data.row.original.address1
    },
    {
      accessorKey: 'adresseURI',
      header: 'Lien',
      cell: (data) => {
        return (
          <InformationToolTip
            align="center"
            icon={
              <Button
                onClick={(e) => {
                  e.stopPropagation()
                  window.open(data.row.original.adresseURI, '_blank')
                }}
                iconSize={25}
                icon={WorldIcon}
                variant="ghost"
                size="small"
                className="p-1"
              />
            }
          >
            <Typography
              variant="label-medium"
              color={tailwindColors.white.DEFAULT}
              className="underline"
              onClick={(e) => {
                e.stopPropagation()
                window.open(data.row.original.adresseURI, '_blank')
              }}
            >
              {data.row.original.adresseURI}
            </Typography>
          </InformationToolTip>
        )
      }
    }
  ]

  return (
    <div>
      <UserNavBar title={'Lieux de RDV'} icon={MeetingPointIcon} />
      <div className="h-4" />
      <DynamicDataTable<TripAddress>
        ref={tableRef}
        title={'Tous les lieu de RDV'}
        columns={columns}
        deleteMessage={{ name: 'le lieu de RDV', attributeName: 'label' }}
        selectable
        allowSearchParam
        endpoint={API.tripAddresses.getAll.url}
        onRowClick={(data, event) =>
          navigateWithEvent(
            Paths.TRIP_ADDRESS_UPDATE_PAGE.replace(':id', data.id.toString()),
            event
          )
        }
        actions={[
          {
            label: 'Ajouter un lieu de RDV',
            icon: PlusIcon,
            type: 'global',
            fn: () => navigate(Paths.TRIP_ADDRESS_CREATE_PAGE)
          }
        ]}
      />
    </div>
  )
}

export default TripAddressListPage
